import { FC } from "react";

import { TasksType } from "@/domain/models/job";
import { I18nKeyType } from "@/i18n";
import { useTranslator } from "@/i18n/useTranslator";

import { DsText, DsTextPropsType } from "../components/ui";
import { DriverTaskCard } from "../interactors";
import { classNames } from "../utils/classNames";

type DriverDashboardSectionPropsType = Pick<DsTextPropsType, "variant"> & {
  title: I18nKeyType;
  titleClassName?: string;
  tasks: TasksType[];
  shouldBlockTaskClick?: boolean;
  shouldApplyDisabledStyles?: boolean;
  shouldShowInProgressBadge?: boolean;
  onTaskClick?: (task: TasksType) => void;
};

const DriverDashboardSection: FC<DriverDashboardSectionPropsType> = ({
  title,
  variant = "pageTitle",
  titleClassName,
  tasks,
  shouldBlockTaskClick,
  shouldApplyDisabledStyles,
  shouldShowInProgressBadge,
  onTaskClick,
}) => {
  const { t } = useTranslator();

  if (!tasks?.length) {
    return null;
  }

  return (
    <div className="mb-7">
      <DsText variant={variant} className={classNames("mb-3", titleClassName)}>
        {t(title)}
      </DsText>

      <ul role="list">
        {tasks?.map(task => {
          return (
            <li key={task.serviceId}>
              <DriverTaskCard
                jobId={task.jobId}
                serviceId={task.serviceId}
                taskId={task.taskId}
                isDisabled={shouldBlockTaskClick}
                shouldApplyDisabledStyles={shouldApplyDisabledStyles}
                shouldShowInProgressBadge={shouldShowInProgressBadge}
                onTaskClick={() => onTaskClick?.(task)}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export { DriverDashboardSection };
